"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateUnique = exports.makePublicNotionUrl = exports.isValidNotionUrl = void 0;
var isEmpty_1 = __importDefault(require("lodash/isEmpty"));
var isValidNotionUrl = function (url) { return (url === null || url === void 0 ? void 0 : url.match(/^https:\/\/(www\.notion\.so\/hudled|hudled\.notion\.site)\/[^/]+-[a-z0-9]{32}$/))
    ? null
    : 'Wrong notion Url'; };
exports.isValidNotionUrl = isValidNotionUrl;
var makePublicNotionUrl = function (url) {
    var matchPrivateUrl = url === null || url === void 0 ? void 0 : url.match(/^https:\/\/www\.notion\.so\/hudled\/([^/]+-[a-z0-9]{32})$/);
    if (matchPrivateUrl) {
        return "https://hudled.notion.site/".concat(matchPrivateUrl[1]);
    }
    return url;
};
exports.makePublicNotionUrl = makePublicNotionUrl;
var validateUnique = function (_a) {
    var pricingInsightsExtUrls = _a.pricingInsightsExtUrls;
    var errors = {};
    if (!pricingInsightsExtUrls)
        return { pricingInsightsExtUrls: 'Missing rows' };
    var checkUniqueField = function (field) { return function (v, idx) {
        if (pricingInsightsExtUrls.slice(0, idx).find(function (v2) { return v2[field] === v[field]; })) {
            if (!errors.pricingInsightsExtUrls)
                errors.pricingInsightsExtUrls = [];
            if (!errors.pricingInsightsExtUrls[idx])
                errors.pricingInsightsExtUrls[idx] = {};
            errors.pricingInsightsExtUrls[idx][field] = "Repeated ".concat(field);
        }
    }; };
    pricingInsightsExtUrls.forEach(function (v, idx) {
        checkUniqueField('url')(v, idx);
        checkUniqueField('productName')(v, idx);
    });
    return (0, isEmpty_1.default)(errors) ? undefined : errors;
};
exports.validateUnique = validateUnique;
